import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GConf from '../../../AssetsM/generalConf';

function PrintPrix() {
    const [articleL, setArticleL] = useState([])
    const [loading , setLoading] = useState(false)
    const bearkList = [27, 54, 81, 108, 135, 162, 189, 216, 243]
    const [articleListe, setArticleListe] = useState([])

    useEffect(() => {
      axios.post(`https://api.system.ansl.tn/API/familia-client/User/suivie-mg-retour`, {
        tag: 'userData.tag',
        clientId : '848565867',

      })
          .then(function (response) {
            let testTable = []
            response.data.map((data) => testTable.push({...data, Genre : GetGenreFunc(data.A_Code) || 'INDEFINE'})
            )
            testTable.sort((a, b) => a.Genre.localeCompare(b.Genre));
            setArticleL(testTable)
            setLoading(true)
          }).catch((error) => {
            if(error.request) {
              setLoading(true)
              
            }
          });
    }, [articleListe])

    useEffect(() => {
        axios.post(`${GConf.ApiLink}/stock`, {
          PID : GConf.PID,
        })
        .then(function (response) {
          setArticleListe(response.data)
        })
  }, [])

  const GetGenreFunc = (Code) => {
    let result = articleListe.find((data) => data.A_Code == Code)
    if (result) {
        return result.Genre
    } else {
        return null
    }
}

    const IsBreackHere = (number) => {
        return bearkList.includes(number)
    }
    const PriceCard = (props) => {
      return(<>
        <span style={{fontSize: '60px'}}><b>{Math.floor(props.number)}</b></span>
        <span style={{fontSize: '26px'}}>,{props.number.toString().split(".")[1]}</span>
      </>)
    }

    return ( <>
                            
                    {loading ?  
                    <>
                    <ul>
                    {articleL.map( (getData, index) => <li key={index} >{getData.Genre} : {getData.Qte}  X  {getData.Name} ({getData.A_Code} ) </li>
                         
                    )}
                    </ul>
                    </>
                    : '...' }                        
                    
           

           
    </> );
}

export default PrintPrix;